import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';

/* 🔹 CHANGE THIS VALUE */
const ITEMS_PER_ROW = 3;

/* ================= STYLES ================= */

const BlogSectionContainer = styled.section`
  width: 100%;
  padding: 100px 0;
  margin-top: 50px;
  background-color: #000000;
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled.h2`
  font-size: 2.3rem;
  margin-bottom: 50px;
  text-align: center;
  font-weight: 700;
  background: linear-gradient(45deg, #ff6b35, #4a90e2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const BlogGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${ITEMS_PER_ROW}, 1fr);
  gap: 32px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const BlogCard = styled.div`
  background: linear-gradient(145deg, #1a1a1a, #0f0f0f);
  border-radius: 18px;
  overflow: hidden;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-8px);
  }
`;

const BlogImage = styled.div`
  height: 250px;
  background-size: cover;
  background-position: center;
`;

const BlogContent = styled.div`
  padding: 24px;
`;

const BlogTitle = styled.h3`
  color: #fff;
  font-size: 1rem;
  margin-bottom: 10px;
`;

const BlogDesc = styled.p`
  color: #ccc;
  font-size: 0.85rem;
  line-height: 1.6;
`;

const BlogMore = styled.span`
  margin-top: 16px;
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 600;
  color: #ff6b35;
  letter-spacing: 1px;
  cursor: pointer;

  &:hover {
    color: #4a90e2;
  }
`;

/* ================= COMPONENT ================= */

const BlogSection = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    axios
      .get(
        'https://blogs.zyntro.in/wp-json/wp/v2/posts?per_page=3&_embed'
      )
      .then(res => setBlogs(res.data))
      .catch(err => console.error('API Error:', err));
  }, []);

  return (
    <BlogSectionContainer>
      <ContentWrapper>
        <SectionTitle>Latest Blog Posts</SectionTitle>

        <BlogGrid>
          {blogs.map(blog => {
            const featuredImage =
              blog._embedded?.['wp:featuredmedia']?.[0]?.source_url;

            return (
              <BlogCard key={blog.id}>
                {featuredImage && (
                  <BlogImage
                    style={{
                      backgroundImage: `url(${featuredImage})`,
                    }}
                  />
                )}

                <BlogContent>
                  <BlogTitle
                    dangerouslySetInnerHTML={{
                      __html: blog.title.rendered,
                    }}
                  />

                  <BlogDesc
                    dangerouslySetInnerHTML={{
                      __html: blog.excerpt.rendered,
                    }}
                  />

                  <BlogMore
                    onClick={() =>
                      (window.location.href = `/blog/${blog.slug}`)
                    }
                  >
                    READ MORE
                  </BlogMore>
                </BlogContent>
              </BlogCard>
            );
          })}
        </BlogGrid>
      </ContentWrapper>
    </BlogSectionContainer>
  );
};

export default BlogSection;
